import http from '../clients/Axios'

export default class StockService {
  async get(keyword = '') {
    const res = await http.get(`/stock/supplier?keyword=${keyword}`)
    return res.data
  }
}
